<template>
    <productGroupsComp />
</template>

<script setup lang="ts">
import { defineAsyncComponent } from 'vue'

const productGroupsComp = defineAsyncComponent(() => import('@/components/managementPages/productGroupsPages/productGroupsComp.vue'))
</script>